import PropTypes from 'prop-types';

import { Box, Checkbox, FormControlLabel } from '@mui/material';

const DayCheckbox = ({
  checkbox: { name, value, onChange, label, disabled },
}) => (
  <Box width="15rem">
    <FormControlLabel
      control={
        <Checkbox
          checked={value}
          onChange={onChange}
          name={name}
          color="primary"
          disabled={disabled}
        />
      }
      label={label}
    />
  </Box>
);
DayCheckbox.propTypes = {
  checkbox: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
    disabled: PropTypes.bool,
  }).isRequired,
};

export default DayCheckbox;
